"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableauWorksheetEvent = void 0;
const TableauSheetEvent_1 = require("./TableauSheetEvent");
class TableauWorksheetEvent extends TableauSheetEvent_1.TableauSheetEvent {
    get worksheet() {
        return this._worksheet;
    }
    constructor(type, _worksheet) {
        super(type, _worksheet);
        this._worksheet = _worksheet;
    }
}
exports.TableauWorksheetEvent = TableauWorksheetEvent;
//# sourceMappingURL=TableauWorksheetEvent.js.map